import { render, staticRenderFns } from "./ShoppingListCartElement.vue?vue&type=template&id=0c0b8c6c&scoped=true&"
import script from "./ShoppingListCartElement.vue?vue&type=script&lang=js&"
export * from "./ShoppingListCartElement.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListCartElement.vue?vue&type=style&index=0&id=0c0b8c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b8c6c",
  null
  
)

export default component.exports